// extracted by mini-css-extract-plugin
export var grid = "newsletter-qotd-module--grid--7a774";
export var image = "newsletter-qotd-module--image--6817c";
export var left = "newsletter-qotd-module--left--89ebb";
export var mark = "newsletter-qotd-module--mark--19890";
export var quote = "newsletter-qotd-module--quote--26296";
export var right = "newsletter-qotd-module--right--8ff21";
export var spin = "newsletter-qotd-module--spin--abf95";
export var wrapper = "newsletter-qotd-module--wrapper--925c9";